/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const CalendarCheckOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M16.5 3v3m-9-3v3M3.75 9h16.5m-4.87 3.75L11 16.87l-2.38-2.24M4.5 4.5h15c.41 0 .75.34.75.75v15c0 .41-.34.75-.75.75h-15c-.41 0-.75-.34-.75-.75v-15c0-.41.34-.75.75-.75z"
})); // Fill


const CalendarCheckFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M19.5 3.75h-2.25V3a.75.75 0 0 0-1.5 0v.75h-7.5V3a.75.75 0 0 0-1.5 0v.75H4.5A1.499 1.499 0 0 0 3 5.25v15a1.499 1.499 0 0 0 1.5 1.5h15a1.499 1.499 0 0 0 1.5-1.5v-15a1.499 1.499 0 0 0-1.5-1.5zm-3.61 9.54-4.38 4.13c-.07.07-.15.12-.23.15-.09.04-.19.06-.28.06a.76.76 0 0 1-.52-.21l-2.37-2.25a.69.69 0 0 1-.18-.24.74.74 0 0 1-.08-.29c0-.1.01-.2.05-.3.03-.09.09-.18.16-.25a.66.66 0 0 1 .24-.17c.1-.04.2-.07.3-.07s.2.02.29.06c.1.04.18.1.25.17L11 15.84l3.86-3.63c.07-.07.15-.13.25-.16.09-.04.19-.06.28-.05.1 0 .2.02.29.06s.17.1.24.17c.14.15.21.34.2.54 0 .2-.09.39-.23.52zm3.61-5.04h-15v-3h2.25V6a.75.75 0 0 0 1.5 0v-.75h7.5V6a.75.75 0 0 0 1.5 0v-.75h2.25v3z"
})); // DuoTone


const CalendarCheckDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M3.75 9h16.5V5.25a.75.75 0 0 0-.75-.75h-15a.75.75 0 0 0-.75.75V9z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M16.5 3v3m-9-3v3M3.75 9h16.5m-4.87 3.75L11 16.87l-2.38-2.24M4.5 4.5h15c.41 0 .75.34.75.75v15c0 .41-.34.75-.75.75h-15c-.41 0-.75-.34-.75-.75v-15c0-.41.34-.75.75-.75z"
}));
/**
  Icon CalendarCheckIcon in time group
*/


export const CalendarCheckIcon = createIcon('CalendarCheckIcon', 'calendar-check', 'time', CalendarCheckOutline, CalendarCheckFill, CalendarCheckDuotone, "0 0 24 24");